import { useMemo } from "react";
import { DeliveryMethods } from "../utils/enum";
import { objectIsEmpty } from "../utils/helpers";
import usePosSettingsHook from "./usePosSettingsHook";

const useIsOrderUserValidHook = ({ selectedDelivery, orderUser }) => {
  const {
    settings: { accept_all_addresses },
  } = usePosSettingsHook();

  const isOrderUserValid = useMemo(() => {
    const { street_name, house_number, telephone, zip_code } = orderUser ?? {};

    if (selectedDelivery === DeliveryMethods.DINE_IN) {
      return true;
    }

    if (
      accept_all_addresses ||
      selectedDelivery === DeliveryMethods.POS_ORDER ||
      selectedDelivery === DeliveryMethods.TAKEAWAY
    )
      return true;
    if (
      selectedDelivery === DeliveryMethods.DELIVERY &&
      (!orderUser || objectIsEmpty(orderUser))
    )
      return false;

    if (
      selectedDelivery === DeliveryMethods.DELIVERY &&
      telephone &&
      street_name &&
      house_number &&
      zip_code
    ) {
      return true;
    }

    return undefined;
  }, [orderUser, selectedDelivery, accept_all_addresses]);

  return { isOrderUserValid };
};

export default useIsOrderUserValidHook;
